export const getColor = (ranking: number, green?: boolean) => {
    if (green && ranking > 0) {
        return '#10f48b'
    } else if (green && ranking === 0) {
        return '#fff'
    } else if (ranking >= 0) {
        return '#D4B578'
    } else if (ranking < 0) {
        return '#EF4150'
    } else return '#D4B578'
}
